import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        if (sid) await googleAuth(sid);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [googleAuth, navigate]);

  return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Connexion en cours…</div>;
}
